export default {
  pages: {
    nasiyaInvoice: {
      banner: {
        title: "Hisob-faktura ma'lumotlari Didox platformasiga joylanadi",
      },
      header: {
        title: 'Hisob-faktura yaratish',
      },
    },
  },
};
